/**
 * Map BFF dashboard response to Group shape for UI (leaderboard, modals).
 * Single place to maintain dashboard → Group mapping when backend adds fields.
 */

import type { Group } from '../../../types/challenges'
import type { GroupDashboardResponse } from '../types/groups.types'

export function dashboardToGroup(dashboard: GroupDashboardResponse | null | undefined): Group | null {
  if (!dashboard) return null
  return {
    id: dashboard.id,
    name: dashboard.name,
    description: dashboard.description,
    creatorId: dashboard.creatorId,
    memberIds: dashboard.memberIds ?? [],
    isPrivate: dashboard.isPrivate,
    allowMemberInvites: dashboard.allowMemberInvites,
    createdAt: new Date(dashboard.createdAt),
    updatedAt: new Date(dashboard.updatedAt),
    myPosition: dashboard.myPosition,
    memberCount: (dashboard.memberIds ?? []).length,
    pendingInvitees: dashboard.pendingInvitees ?? [],
  }
}
